import { AfterViewInit, Component, inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { LoginService } from '../../../core/services/Login/login.service'; 
import { Router } from '@angular/router';
import { CustomErrorStateMatcher } from '../../../core/models/CustomErrorStateMatcher';
import { AesEncDecService } from '../../../core/services/aes/aes-enc-dec.service';
import { ResponseVm } from '../../../core/models/response-vm';
import { LoginHeaderComponent } from '../../../shared/components/login-header/login-header.component'; 
import { FooterComponent } from '../../../shared/components/app-footer/footer.component'; 
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-signup',
  standalone: true,
  imports: [CommonModule, MatLabel, FormsModule, ReactiveFormsModule, MatFormField, MatInput, 
    MatError,MatProgressSpinner,
    LoginHeaderComponent,FooterComponent
  ],
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  private router = inject(Router);
  loginService = inject(LoginService);
  security = inject(AesEncDecService);
  matcher = new CustomErrorStateMatcher();
  loginFailedMessage: string;
  signupForm: FormGroup;
  formValues: any;
  isLoading = false;

  constructor(private fb: FormBuilder) {
    this.signupForm = this.fb.group({
      userId: new FormControl('', [Validators.required]),
      pin: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required])
    });
  }

  ngOnInit(): void {
    localStorage.clear();
  }

  receiveFormValues(values: any): void {
    this.formValues = values;
  }

  onSubmit() {
    this.isLoading = true;
    this.formValues = this.signupForm.value;
    this.loginService.firstTimeLogin(this.formValues).subscribe({
      next: (response: ResponseVm) => {
        if(response.loginDetails!=null){
        console.log(response.loginDetails);
        this.security.saveData("loginUserId", JSON.stringify(this.formValues.userId)); 
        this.router.navigateByUrl('otp-page');
      }
      else{
        this.isLoading = false;
       this.loginFailedMessage=response.responseMessage;
      }
    },
      error: error => {
        this.isLoading = false;
        this.loginFailedMessage='There was an error!'
        console.error('There was an error!', error);
      }
    });
  }
}